import React, { Component } from 'react'
import { Section, Page, withSizes } from './common'
import Footer from './Footer'
import Article from './Article'
import { gqlConnect } from 'react-connect-graphql-beta'
import { monthNames } from '../utils/MonthNames'
import { connect } from 'react-redux'
import DocumentMeta from 'react-document-meta'
import {
  _description,
  _image,
  _keywords,
  _title,
  getMeta,
  parseKeywords,
} from '../utils/defaultMeta'
import { setDarkMode } from '../redux/actions/navBar'
import { withSplash } from '../hocs/withSplash'
import {formatMetaTitle} from "../utils/formatMetaTitle";

class PrivacyPolicy extends Component {
  constructor(props) {
    super(props)

    this.state = {
      header: this.getHeader(),
      sections: this.getSections(),
    }
  }

  componentDidMount() {
    const { setDarkMode } = this.props
    setDarkMode(false)
  }

  componentWillUnmount() {
    const { setDarkMode } = this.props
    setDarkMode(true)
  }

  getHeader = () => {
    const { getStyle } = this.props
    return {
      styles: getStyle(styles.header),
      scrollImg: undefined,
    }
  }

  getSections = () => {
    const { data } = this.props.gql
    const { getStyle } = this.props

    const newText = data.privacyText.replace(/(\r\n|\n|\r)/gm, '')

    const articleData = {
      newsPostBody: [
        {
          typeHandle: 'text',
          text: newText,
        },
      ],
    }

    const date = new Date(data.privacyDate)

    const dateStr = `${
      monthNames[date.getMonth()]
    } ${date.getDate()}, ${date.getFullYear()}`

    return (
      <Section styles={styles.section}>
        <div style={getStyle(styles.topWrapper)}>
          <div style={styles.headerText}>{data.title}</div>
          <div style={styles.date}>{dateStr}</div>
        </div>
        <Article styles={styles.article} data={articleData} />
      </Section>
    )
  }
  render() {
    const { header } = this.state
    const { getSections } = this
    const { data } = this.props.gql
    const { metadata } = this.props

    return (
      <DocumentMeta
        {...getMeta(
          formatMetaTitle(data?.title || _title, metadata?.siteName, metadata?.shortSiteName, metadata?.titleDelimiter, metadata?.siteNameCharacterLimit),
          data.seoDescription || _description,
          data?.seoImage[0]?.url || _image,
          data.seoKeywords.length > 0
            ? parseKeywords(data.seoKeywords)
            : _keywords,
        )}>
        <Page
          styles={styles.page}
          header={header}
          sections={getSections()}
          showFooter={true}
          showContactForm={false}
          footer={<Footer />}
        />
      </DocumentMeta>
    )
  }
}

const styles = {
  page: {
    container: {
      backgroundColor: 'white',
    },
  },
  section: {
    container: {
      paddingLeft: 50,
      paddingRight: 50,
      paddingBottom: 50,
    },
  },
  header: {
    container: {
      height: 175,
    },
  },
  topWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    xs: {
      alignItems: 'flex-start',
    },
  },
  headerText: {
    color: '#852D3D',
    fontSize: 55,
    fontFamily: 'capitolina',
    fontWeight: 'bold',
  },
  date: {
    color: '#404144',
    fontSize: 30,
    marginBottom: 100,
  },
}

const mapStateToProps = (state) => {
  return {
    metadata: state.metadata
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setDarkMode: (isDarkMode) => dispatch(setDarkMode(isDarkMode)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(gqlConnect('privacy')(withSizes(withSplash(PrivacyPolicy))))
